export default __webpack_public_path__ + "static/06_Bibliography.pdf";